// utils/logout.ts
export const handleLogout = () => {
  localStorage.removeItem('jwt');
  window.location.href = '/admin/login';
};